import * as React from "react";
import styled  from "styled-components";

import {
    Grid,
    Hidden,
    AppBar as MuiAppBar,
    IconButton as MuiIconButton,
    Toolbar, Typography
} from "@material-ui/core";

import { Menu as MenuIcon } from "@material-ui/icons";

import {useHistory} from 'react-router';
import { PAGE_HEADER_ACTIONS_SLOT_ID, PAGE_TITLE_SLOT_ID } from "shared/ui";
import { useOrganizationBranchDetails } from "shared/hooks/useOrganizationBranchDetails";
import { isPaymentSoon, tariffStatusOf, timeLeftLabel } from "shared/lib/tariffStatus";


const AppBar = styled(MuiAppBar)`
  background: ${props => props.theme.header.background};
  color: ${props => props.theme.header.color};
  box-shadow: ${props => props.theme.shadows[1]};
`;

/*
* Плашка тарифа: своя, а не Button кита — у неё три статусных цвета, которых в системе
* вариантов кита нет, и городить их туда ради одного места в шапке незачем.
* */
const TariffPill = styled.button<{ $tone: "active" | "overdue" | "expired" }>`
  border: 0;
  border-radius: 20px;
  padding: 6px 16px;
  font-family: inherit;
  font-size: 14px;
  font-weight: 400;
  cursor: pointer;
  color: ${props => tariffTones[props.$tone].color};
  background: ${props => tariffTones[props.$tone].background};
`;

const tariffTones = {
  active: { color: "#2d81e0", background: "rgba(96,149,236,0.12)" },
  overdue: { color: "#724800", background: "rgba(255,206,116,0.3)" },
  expired: { color: "#ee412b", background: "rgba(221,71,59,0.12)" },
};

const IconButton = styled(MuiIconButton)`
  svg {
    width: 22px;
    height: 22px;
  }
`;

/*const Indicator = styled(Badge)`
  .MuiBadge-badge {
    background: ${props => props.theme.header.indicator.background};
    color: ${props => props.theme.palette.common.white};
  }
`;*/


/*
* Состояние тарифа берём из REST (GET /organization-branch) — тем же хуком, что и страница
* тарифа, поэтому подпись в шапке и на странице всегда об одном.
* */
const TariffButton = () => {
    const { branch, loading } = useOrganizationBranchDetails();
    const history = useHistory();

    if (loading || !branch) return null;

    const tariff = branch.tariff;
    const now = Date.now();
    const status = tariffStatusOf(tariff, now);

    const buttonTexts = {
        active: isPaymentSoon(tariff, now)
            ? `До оплаты ${timeLeftLabel(tariff.nextPaymentDate, now)}`
            : "Тариф оплачен",
        overdue: `Меню активны ещё ${timeLeftLabel(tariff.menusActiveTillDate, now)}`,
        expired: "Тариф истёк"
    }

    return (
        <TariffPill $tone={status} onClick={() => history.push("/settings/tariff")}>
            {buttonTexts[status]}
        </TariffPill>
    )
}

interface OwnProps {
    onDrawerToggle: React.MouseEventHandler<HTMLElement>;
}

const Header: React.FC<OwnProps> = ({ onDrawerToggle }) => {
    return <>
        <AppBar position="sticky" elevation={0}>
            <Toolbar>
                <Grid container alignItems="center">
                    <Hidden lgUp>
                        <Grid item>
                            <IconButton
                                color="inherit"
                                aria-label="Open drawer"
                                onClick={onDrawerToggle}
                            >
                                <MenuIcon/>
                            </IconButton>
                        </Grid>
                    </Hidden>
                    {/*
                      Заголовок и кнопки страницы приезжают сюда порталами из самой страницы
                      (shared/ui/HeaderSlot): так они остаются в её React-дереве и видят её
                      контекст — счётчики, диалоги, данные фичи.
                    */}
                    <Grid item>
                        <Typography
                            variant="h4"
                            display="block"
                            id={PAGE_TITLE_SLOT_ID}
                            style={{ color: "#000", marginLeft: 10, display: "flex" }}
                        />
                    </Grid>
                    <Grid item xs/>
                    <Grid item>
                        <div
                            id={PAGE_HEADER_ACTIONS_SLOT_ID}
                            style={{ display: "flex", alignItems: "center" }}
                        />
                    </Grid>
                    <Hidden smDown>
                        <Grid item>
                            <div style={{ minWidth: 20, display: "inline-block" }}/>
                            {/*<IconButton color="inherit">
                            <Indicator badgeContent={3}>
                                <MessageSquare />
                              </Indicator>
                            </IconButton>

                           {/* <IconButton color="inherit">
                                <Indicator badgeContent={7}>
                                    <Bell/>
                                </Indicator>
                            </IconButton>*/}
                            {/*<LanguageMenu />*/}
                            {/*
                              Плашка тарифа — только на широкой шапке (lg+). Ниже 1280
                              место занимают действия страницы, и статус тарифа туда
                              уже не помещается; он остаётся доступен на странице тарифа.
                            */}
                            <Hidden mdDown>
                                <TariffButton/>
                            </Hidden>
                        </Grid>
                    </Hidden>
                </Grid>
            </Toolbar>
        </AppBar>
    </>
};

export default Header;
